module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage",
    attrs: {
      "id": "sec-5"
    }
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "margin-bottom": "3em"
    },
    attrs: {
      "id": "pAkY"
    }
  }, [_vm._v("\n\t\t\t\t\tFINDING THEIR VOICES"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("SERMONS BY WOMEN IN THE CHURCHES OF CHRIST")])]), _vm._v(" "), _c('h2', {
    staticClass: "author",
    staticStyle: {
      "margin-bottom": "5em"
    },
    attrs: {
      "id": "pz5-2"
    }
  }, [_vm._v("\n\t\t\t\t\tD’ESTA LOVE ")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pz5-3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-5-1.png",
      "id": "z5-3",
      "src": "images/himg-5-1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fae8e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 63
// module chunks = 0